<!--企业发展-->
<template>
  <div class="enterpriseDevelopment">
    <!--融资历程-->
    <div ref="development0" class="first-content">
      <div class="title-min SourceHanSansCN">融资历程<span class="quota">{{ financingProcess.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable46" :data="financingProcess" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="financingName" title="披露日期"/>
          <vxe-column field="money" title="交易金额"/>
          <vxe-column field="financingType" title="融资轮次"/>
          <vxe-column field="valuation" title="估值"/>
          <vxe-column field="proportion" title="比例"/>
          <vxe-column field="investor" title="投资方">
            <template #default="{ row }">
              <span v-for="(investor,index) in row.investor">
                <span v-if="index==0">{{ investor }}</span>
                <span v-else>，{{ investor }}</span>
              </span>
            </template>
          </vxe-column>
          <vxe-column field="dataSources" title="数据来源"/>
        </vxe-table>
      </div>
    </div>
    <!--核心团队-->
    <div ref="development1" class="essential-content">
      <div class="title-min SourceHanSansCN">核心团队<span class="quota">{{ coreTeam.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="coreTeam" :data="coreTeam" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="name" title="姓名" width="150">
            <template #default="{ row }">
              <el-avatar shape="square" fit="contain" style="height: 60px;width: 60px;">
                <div class="legal" :style="'background:'+createRandomColor()+''">
                  <span v-for="(word,index) of logoword(row.name)" class="logo-word"v-if="index<4">{{ word }}</span>
                </div>
              </el-avatar>
              <el-link type="primary" :underline="false" class="avatar-title"
                       style="margin-left: 10px;line-height: 60px;">{{ row.name }}
              </el-link>
            </template>
          </vxe-column>
          <vxe-column field="position" title="职位" width="230"/>
          <vxe-column field="synopsis" title="简介"/>
        </vxe-table>
      </div>
    </div>
    <!--企业业务-->
    <div ref="development2" class="essential-content">
      <div class="title-min SourceHanSansCN">企业业务<span class="quota">{{ enterpriseService.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable48" :data="enterpriseService" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="title" title="产品名称">
            <template #default="{ row }">
              <el-avatar shape="square" fit="contain" :src="row.icon" style="width: 60px;height: 60px;"
                         v-if="row.icon!=null && row.icon!='https://aiqicha.baidu.com//static/pc/photo/logo.png' && row.icon!='http://aiqicha.baidu.com//static/pc/photo/logo.png' && row.icon!='https://aiqicha.baidu.com/static/pc/photo/logo.png' && row.icon!='http://aiqicha.baidu.com/static/pc/photo/logo.png'"/>
              <el-avatar shape="square" fit="contain" style="height: 60px;width: 60px;" v-else>
                <div class="legal" :style="'background:'+createRandomColor()+''">
                  <span v-for="(tit,index) of logoword(row.title)" class="logo-word" v-if="index<4">{{ tit }}</span>
                </div>
              </el-avatar>
              <el-link type="primary" :underline="false" class="avatar-title" @click="enterpriseBusinessDetails(row)"
                       style="margin-left: 10px;line-height: 60px;">{{ row.title }}
              </el-link>
            </template>
          </vxe-column>
          <vxe-column field="dateEstablishment" title="成立日期" width="85"/>
          <vxe-column field="financingRound" title="当前融资轮次" width="150"/>
          <vxe-column field="productLabeling" title="产品标签" width="340">
            <template #default="{ row }">
              <span v-for="(product,index) in row.productLabeling">
                <span v-if="index==0">{{ product }}</span>
                <span v-else>，{{ product }}</span>
              </span>
            </template>
          </vxe-column>
          <vxe-column field="territory" title="所属地" width="120"/>
          <vxe-column field="productIntroduction" title="产品介绍"/>
        </vxe-table>
      </div>
    </div>
    <!--竞品信息-->
    <div ref="development3" class="essential-content">
      <div class="title-min SourceHanSansCN">竞品信息<span class="quota">{{ tablePage.total }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable49" :data="competitorInfo" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="title" title="产品名称">
            <template #default="{ row }">
              <el-avatar shape="square" fit="contain" :src="row.newEnterpriseBusinesDom.icon" style="width: 60px;height: 60px;"
                         v-if="row.newEnterpriseBusinesDom.icon!=null && row.newEnterpriseBusinesDom.icon!='https://aiqicha.baidu.com//static/pc/photo/logo.png' && row.newEnterpriseBusinesDom.icon!='http://aiqicha.baidu.com//static/pc/photo/logo.png' && row.newEnterpriseBusinesDom.icon!='https://aiqicha.baidu.com/static/pc/photo/logo.png' && row.newEnterpriseBusinesDom.icon!='http://aiqicha.baidu.com/static/pc/photo/logo.png'"/>
              <el-avatar shape="square" fit="contain" style="height: 60px;width: 60px;" v-else>
                <div class="legal" :style="'background:'+createRandomColor()+''">
                  <span v-for="(dom,index) of logoword(row.newEnterpriseBusinesDom.title)" class="logo-word"v-if="index<4">
                    {{dom}}
                  </span>
                </div>
              </el-avatar>
              <el-link type="primary" :underline="false" class="avatar-title"
                       style="margin-left: 10px;line-height: 60px;">{{ row.newEnterpriseBusinesDom.title || '-' }}
              </el-link>
            </template>
          </vxe-column>
          <vxe-column field="dateEstablishment" title="成立日期" width="120">
            <template #default="{ row }">
              <span>{{ row.newEnterpriseBusinesDom.dateEstablishment || '-' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="financingRound" title="当前融资轮次" width="120">
            <template #default="{ row }">
              <span>{{ row.newEnterpriseBusinesDom.financingRound || '-' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="tag" title="产品标签">
            <template #default="{ row }">
              <span v-for="(labeling,index) in row.newEnterpriseBusinesDom.productLabeling">
                <span v-if="index==0">{{ labeling }}</span>
                <span v-else>，{{ labeling }}</span>
              </span>
            </template>
          </vxe-column>
          <vxe-column field="territory" title="所属地">
            <template #default="{ row }">
              <span>{{ row.newEnterpriseBusinesDom.territory || '-' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="productIntroduction" title="产品介绍">
            <template #default="{ row }">
              <span>{{ row.newEnterpriseBusinesDom.productIntroduction || '-' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="companyName" title="所属公司">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="getCompanyDataList(row.newEnterpriseBusinesDom.cid)">
                {{ row.newEnterpriseBusinesDom.companyName || '-' }}
              </el-link>
            </template>
          </vxe-column>
        </vxe-table>
        <!-- 分页 -->
        <div style="padding:10px 30px; height: 30px;">
          <page :total="tablePage.total" @currentPage="currentPage" :limit="tablePage.pageSize" style="float: right;"/>
        </div>
      </div>
    </div>
    <!--投资机构-->
    <div ref="development4" class="essential-content">
      <div class="title-min SourceHanSansCN">投资机构<span class="quota">{{ QFIIInfo.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable50" :data="QFIIInfo" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="organizationName" title="投资机构" width="360">
            <template #default="{ row }">
              <el-avatar shape="square" @click="organizationDetails(row)" fit="contain" :src="row.organizationLogo" style="width: 60px;height: 60px;"
                         v-if="row.organizationLogo!=null && row.organizationLogo!='https://aiqicha.baidu.com//static/pc/photo/logo.png' && row.organizationLogo!='http://aiqicha.baidu.com//static/pc/photo/logo.png' && row.organizationLogo!='https://aiqicha.baidu.com/static/pc/photo/logo.png' && row.organizationLogo!='http://aiqicha.baidu.com/static/pc/photo/logo.png'"/>
              <el-avatar shape="square" @click="organizationDetails(row)" fit="contain"
                         style="height: 60px;width: 60px;" v-else>
                <div class="legal" :style="'background:'+createRandomColor()+''">
                  <span v-for="(legal,index) of logoword(row.organizationName)" class="logo-word"v-if="index<4">{{ legal }}</span>
                </div>
              </el-avatar>
              <el-link type="primary" :underline="false" class="avatar-title" @click="organizationDetails(row)" style="padding-left: 10px">
                {{ row.organizationName || '-' }}
              </el-link>
            </template>
          </vxe-column>
          <vxe-column field="dateEstablishment" title="成立日期" width="120"/>
          <vxe-column field="territory" title="所属地" width="100"/>
          <vxe-column field="briefIntroduction" title="简介"/>
        </vxe-table>
      </div>
    </div>
    <!--私募基金-->
    <div ref="development5" class="essential-content">
      <div class="title-min SourceHanSansCN">私募基金<span class="quota">{{ privateOfferFund.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable51" :data="privateOfferFund" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="companyName" title="私募基金管理人名称" width="360">
            <template #default="{ row }">
              <el-avatar shape="square" fit="contain" :src="row.companyLogo" style="width: 60px;height: 60px;"
                         v-if="row.companyLogo!=null && row.companyLogo!='https://aiqicha.baidu.com//static/pc/photo/logo.png' && row.companyLogo!='http://aiqicha.baidu.com//static/pc/photo/logo.png' && row.companyLogo!='https://aiqicha.baidu.com/static/pc/photo/logo.png' && row.companyLogo!='http://aiqicha.baidu.com/static/pc/photo/logo.png'"/>
              <el-avatar shape="square" fit="contain" style="height: 60px;width: 60px;" v-else>
                <div class="legal" :style="'background:'+createRandomColor()+''">
                  <span v-for="(legal,index) of logoword(row.entLogoWord)" class="logo-word"v-if="index<4">{{ legal }}</span>
                </div>
              </el-avatar>
              <div class="avatar-title" style="padding-left: 10px;">{{ row.companyName }}</div>
            </template>
          </vxe-column>
          <vxe-column field="name" title="法定代表人/执行事务合伙人"/>
          <vxe-column field="organizationType" title="机构类型"/>
          <vxe-column field="registrationNumber" title="登记编号"/>
          <vxe-column field="establishmentTime" title="成立日期" width="120"/>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="privateOfferDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--企业业务详情-->
    <el-dialog title="企业业务详情" :visible.sync="Dialog31" style="z-index: 9999">
      <el-row>
        <el-col :span="24">
          <div class="demo-basic--circle" style="float: left;">
            <el-avatar shape="square" fit="contain" v-if="businessDetail.icon" :src="businessDetail.icon"
                       style="height: 95px;width: auto;float: left;margin-right: 15px;min-width: 95px;"/>
            <el-avatar shape="square" style="height: 95px;width: auto;float: left;margin-right: 15px;min-width: 95px;"
                       fit="contain" v-else>{{ businessDetail.title }}
            </el-avatar>
          </div>
          <div class="userName" style="margin-top: 0px;padding-left: 110px;">{{ businessDetail.title || '-' }}</div>
          <div class="text-t1">所属公司：{{ businessDetail.companyName || '-' }}</div>
          <div class="text-t1">当前融资轮次：{{ businessDetail.financingRound || '-' }}</div>
          <div class="text-t1">成立日期：{{ businessDetail.dateEstablishment || '-' }}</div>
          <div class="text-t1">所属地：{{ businessDetail.territory || '-' }}</div>
          <div class="text-t1" style="line-height: 32px;">简介：{{ businessDetail.productIntroduction || '-' }}</div>
        </el-col>
      </el-row>
    </el-dialog>
    <!--企业基本信息-->
    <el-dialog title="企业基本信息" :visible.sync="Dialog38" style="z-index: 9999">
      <el-row>
        <el-col :span="24">
          <div class="demo-basic--circle" style="float: left;">
            <el-avatar shape="square" style="width: auto" fit="contain" v-if="companyData.companyLogo" :src="companyData.companyLogo"/>
            <el-avatar shape="square" style="width: 95px;height: 95px;" fit="contain" v-else-if="companyData.entLogoWord">
              <div style="width: 95px;font-size: 50px;line-height: initial;padding: 7px 5px;height: 95px;" v-if="companyData.entLogoWord.length>2">
                {{ companyData.entLogoWord }}
              </div>
              <div style="font-size: 50px;" v-else>{{ companyData.entLogoWord }}</div>
            </el-avatar>
            <el-avatar shape="square" style="width: 95px;height: 95px;" fit="contain" v-else/>
          </div>
          <div style="padding-left: 30px;float: left;width: 80%">
            <div class="userName" style="margin-top: 0px;">{{ companyData.companyName || '-' }}</div>
            <div class="text-t2">法定代表人：{{ companyData.name || '-' }}</div>
            <div class="text-t2">统一社会信用代码：{{ companyData.unifiedSocialCreditCode || '-' }}</div>
            <div class="text-t2">电话：{{ companyData.telephony || '-' }}</div>
            <div class="text-t2">官网：{{ companyData.website || '-' }}</div>
            <div class="text-t2">邮箱：{{ companyData.mailbox || '-' }}</div>
            <div class="text-t2">地址：{{ companyData.address || '-' }}</div>
            <div CLASS="text-t2" style="line-height: 32px;">简介：{{ companyData.synopsis || '-' }}</div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import page from "@/components/page/pages";
import {
  financingHistory,
  coreTeamPageList,
  enterpriseBusinessPageList,
  newGetEnterpriseBusinessEssentialInformation,
  competitiveProductsInfo,
  investmentAgencyList,
  getPrivateOfferingFundList,
  getCompanyInfo
} from '@/api/enterpriseDetailsApi'
Vue.use(VXETable)
export default {
  name: "enterpriseDevelopment",
  components: {page},
  data() {
    return {
      /*融资历程*/
      financingProcess: [],
      /*核心团队*/
      coreTeam: [],
      /*企业业务*/
      enterpriseService: [],
      /*竞品信息*/
      competitorInfo: [],
      /*投资机构*/
      QFIIInfo: [],
      /*私募基金*/
      privateOfferFund: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      Dialog31: false,
      Dialog38: false,
      /*企业业务详情*/
      businessDetail: {},
      /*公司详情*/
      companyData: {},
    }
  },
  props: {
    corpId: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  computed: {
    logoword() {
      return function (word) {
        if (word)
          return word.split('');
        else
          return [];
      }
    }
  },
  methods: {
    /*随机生成颜色值*/
    createRandomColor() {
      let num = Math.floor(Math.random() * 9 + 1);
      let colorList = ['#7db3d9', '#d1ae9d', '#ca8484', '#bc9edd', '#8B658B', '#B22222', '#27408B', '#008B8B', '#5D478B', '#68228B'];
      return colorList[num];
    },
    /*融资历程*/
    getFinancingHistory() {
      financingHistory({cid: this.corpId, request: 'form'}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          res.content.forEach(function (row) {
            if (row.investor != '' && row.investor != undefined && row.investor != null) {
              row.investor = JSON.parse(row.investor.replace(/\'/g, '"'));
            }
          })
          this.financingProcess = res.content;
        }
      })
    },
    /*核心团队*/
    getCoreTeamPageList() {
      coreTeamPageList({cid: this.corpId, request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          this.coreTeam = res.content.rows;
        }
      })
    },
    /*企业业务*/
    getEnterpriseBusinessPageList() {
      enterpriseBusinessPageList({cid: this.corpId, request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          res.content.rows.forEach(function (rows) {
            if (rows.productLabeling != '' && rows.productLabeling != null && rows.productLabeling != undefined) {
              rows.productLabeling = JSON.parse(rows.productLabeling.replace("\\u005c", ""))
            }
          })
          this.enterpriseService = res.content.rows;
        }
      })
    },
    /*企业业务详情*/
    enterpriseBusinessDetails(row) {
      newGetEnterpriseBusinessEssentialInformation({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          this.businessDetail = res.content;
          this.Dialog31 = true;
        }
      })
    },
    /*竞品信息*/
    getCompetitiveProductsInfo() {
      competitiveProductsInfo({cid: this.corpId, request: 'form', page: this.tablePage.currentPage}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          res.content.rows.forEach(function (row) {
            if (row.newEnterpriseBusinesDom != '' && row.newEnterpriseBusinesDom != null && row.newEnterpriseBusinesDom != undefined) {
              if (row.newEnterpriseBusinesDom.productLabeling != '' && row.newEnterpriseBusinesDom.productLabeling != null && row.newEnterpriseBusinesDom.productLabeling != undefined) {
                row.newEnterpriseBusinesDom.productLabeling = JSON.parse(row.newEnterpriseBusinesDom.productLabeling.replace("\\u005c", ""))
              }
            }
          })
          this.competitorInfo = res.content.rows;
          this.tablePage.total = parseInt(res.content.total);
        }
      })
    },
    /*投资机构*/
    getInvestmentAgencyList() {
      investmentAgencyList({cid: this.corpId, request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          this.QFIIInfo = res.content.rows;
        }
      })
    },
    /*私募基金*/
    getPrivateOfferingFundListBase() {
      this.privateOfferFund = [];
      getPrivateOfferingFundList({cid: this.corpId, request: 'form'}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          if (res.content != '' && res.content != undefined && res.content != null) {
            this.privateOfferFund.push(res.content);
          }
        }
      })
    },
    /*公司详情*/
    getCompanyDataList(cid) {
      getCompanyInfo({id: parseInt(cid), request: 'form'}).then(obj => {
        if (obj.code == 200) {
          this.Dialog38 = true;
          this.companyData = obj.content;
        }
      })
    },
    /*投资机构详情*/
    organizationDetails(row) {
      this.$router.push({path: '/enterpriseDetails/investmentInstitutions?id=' + row.id + '&cid=' + this.corpId});
    },
    /*私募基金详情*/
    privateOfferDetail(row) {
      // this.$router.push({path: '/businessManagement/fundDetails?cid=' + row.cid});
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getCompetitiveProductsInfo();
    },
    /*定位到指定位置*/
    scrollToArea(ref) {
      window.scrollTo(0, this.$refs[ref].offsetTop - 200);
    }
  },
  mounted() {
    this.getFinancingHistory();
    this.getCoreTeamPageList();
    this.getEnterpriseBusinessPageList();
    this.getInvestmentAgencyList();
    this.getPrivateOfferingFundListBase();
  }
}
</script>

<style lang="scss" scoped>
.enterpriseDevelopment {
  .first-content {
    background: white;
  }

  .essential-content {
    background: white;
    margin-top: 10px;
    padding-bottom: 20px;

    .span-red {
      color: #FE273B;
      font-weight: bold
    }

    .el-row-lightblue {
      background: #F1F7FC;
      padding: 30px 0px;
      text-align: center;
      margin: 0px 30px 10px;
    }

    .result-left {
      margin-bottom: 15px;
      color: #222222;
      font-size: 16px;
      padding: 0px 30px;
    }

    .result-left2 {
      margin-bottom: 15px;
      margin-top: 30px;
      color: #222222;
      font-size: 16px;
      padding: 0px 30px;
    }

    .col-8 {
      text-align: left;
      background: #F3F9FC;
      border: 0.5pt solid #e5eef6;
      padding: 15px 0 15px 20px;
    }

    .col-9 {
      text-align: left;
      background: #ffffff;
      border: 0.5pt solid #e5eef6;
      padding: 15px 0 15px 20px;
    }
  }

  .quota {
    padding-left: 10px;
    color: #2B79FE;
  }

  .title-min {
    padding: 20px 30px;
    font-size: 16px;
    font-weight: bold;
    color: #222222;
  }

  .legal {
    height: 60px;
    width: 60px;
    font-size: 18px;
    color: #ffffff;
    font-weight: 500;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0px;

    .logo-word {
      width: 34%;
      height: 34%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .el-avatar {
    background: white;
    border: 1px solid rgba(0, 0, 0, .05);
    border-radius: 6px;
    height: 50px;
    width: 50px;
    line-height: 48px;
    float: left;
    color: #333333;
  }

  .avatar-title {
    text-align: left;
    color: #333333;
    line-height: normal;
  }

  .none-content {
    margin: 10px 30px 20px;
    height: 120px;
    text-align: center;
    line-height: 120px;
    border: 1px solid #EEEEEE;
    background: #ffffff;
  }

  .userName {
    font-size: 20pt;
    color: #333333;
    margin-top: 30px;
    font-weight: bold;
  }

  .text-t1 {
    font-size: 12pt;
    color: #333333;
    padding-left: 85pt;
    margin-top: 10px;
  }

  .text-t2 {
    font-size: 12pt;
    color: #333333;
    margin-top: 10px;
  }

  .table-menu {
    padding: 0px 0px 20px;
  }

  .table-x-table {
    margin: 0px 30px;
    border: 0.5pt solid #e5eef6;
  }
}
</style>